import { render } from "./tender_request.vue?vue&type=template&id=2f5da77f"
import script from "./tender_request.vue?vue&type=script&lang=js"
export * from "./tender_request.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/contragent/tender/request/tender_request.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f5da77f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f5da77f', __exports__)) {
    console.log('reload')
    api.reload('2f5da77f', __exports__)
  }
  
  module.hot.accept("./tender_request.vue?vue&type=template&id=2f5da77f", () => {
    console.log('re-render')
    api.rerender('2f5da77f', render)
  })

}


export default __exports__